var $6c14ae2b766b652c$exports = {};
$6c14ae2b766b652c$exports = {
  "Empty": "Pr\xE1zdne"
};
export { $6c14ae2b766b652c$exports as default };